import React from 'react';

type Props = {
  active?: boolean;
  children: React.ReactNode;
  /** Drop the right margin so the icon centers in the collapsed rail. */
  collapsed?: boolean;
};

const SidenavIcon: React.FC<Props> = ({ children, active, collapsed }) => {
  return (
    <span
      aria-hidden="true"
      className={[
        collapsed
          ? 'inline-flex h-6 w-6 shrink-0 items-center justify-center transition ease-in-out duration-150'
          : 'mr-3 inline-flex h-6 w-6 shrink-0 items-center justify-center transition ease-in-out duration-150',
        active
          ? 'text-primary-600 dark:text-primary-400'
          : 'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600',
      ].join(' ')}
    >
      {children}
    </span>
  );
};

export default SidenavIcon;
